import React, { useState } from 'react';
import api from '../services/api';
import { FormCard, Field, Button, Grid2 } from '../pages/FoodPremisesStyles';

const FoodPremisesApplicationForm = ({ onSuccess, user }) => {
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    premisesName: '',
    businessOwnerName: '',
    contactNumbers: user?.username || '',
    email: '',
    physicalAddress: '',
    county: '',
    district: '',
    typeOfPremises: [],
    productCategories: [],
    otherProductCategory: '',
    numberOfEmployees: '',
    businessRegistrationNumber: '',
    falPremisesCode: '',
    dateOfListing: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e, group) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      const current = prev[group];
      if (checked) {
        return { ...prev, [group]: [...current, value] };
      } else {
        return { ...prev, [group]: current.filter(item => item !== value) };
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const response = await api.foodPremises.apply(formData);
      if (onSuccess) onSuccess(response);
    } catch (error) {
      alert(error.message || 'Failed to submit application');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <FormCard>
      <form onSubmit={handleSubmit}>
        <Field>
          <label>1. Premises Name</label>
          <input name="premisesName" value={formData.premisesName} onChange={handleInputChange} required />
        </Field>

        <Field>
          <label>2. Business Owner Name</label>
          <input name="businessOwnerName" value={formData.businessOwnerName} onChange={handleInputChange} required />
        </Field>

        <Grid2>
          <Field>
            <label>3. Contact Number(s) (Username)</label>
            <input name="contactNumbers" value={formData.contactNumbers} onChange={handleInputChange} required placeholder="e.g. 0770123456" />
          </Field>
          <Field>
            <label>4. Email Address</label>
            <input type="email" name="email" value={formData.email} onChange={handleInputChange} required />
          </Field>
        </Grid2>

        <Field>
          <label>5. Physical Address</label>
          <textarea name="physicalAddress" value={formData.physicalAddress} onChange={handleInputChange} required />
        </Field>

        <Grid2>
          <Field>
            <label>6. County</label>
            <input name="county" value={formData.county} onChange={handleInputChange} required />
          </Field>
          <Field>
            <label>District</label>
            <input name="district" value={formData.district} onChange={handleInputChange} required />
          </Field>
        </Grid2>

        <Field>
          <label>7. Type of Premises</label>
          <div className="checkbox-group">
            {['Retailer', 'Wholesaler', 'Processor', 'Importer', 'Distributor'].map(type => (
              <label key={type}>
                <input 
                  type="checkbox" 
                  value={type} 
                  checked={formData.typeOfPremises.includes(type)}
                  onChange={(e) => handleCheckboxChange(e, 'typeOfPremises')}
                />
                {type}
              </label>
            ))}
          </div>
        </Field>

        <Field>
          <label>8. Product Categories</label>
          <div className="checkbox-group">
            {['Dairy', 'Beverages', 'Canned Goods', 'Bakery', 'Frozen Foods', 'Spices', 'Oils', 'Cereals', 'Snacks'].map(cat => (
              <label key={cat}>
                <input 
                  type="checkbox" 
                  value={cat} 
                  checked={formData.productCategories.includes(cat)}
                  onChange={(e) => handleCheckboxChange(e, 'productCategories')}
                />
                {cat}
              </label>
            ))}
          </div>
          <div style={{ marginTop: 8 }}>
            <label style={{ fontSize: 12 }}>Others:</label>
            <input name="otherProductCategory" value={formData.otherProductCategory} onChange={handleInputChange} placeholder="Specify other categories..." />
          </div>
        </Field>

        <Grid2>
          <Field>
            <label>9. Number of Employees</label>
            <input type="number" name="numberOfEmployees" value={formData.numberOfEmployees} onChange={handleInputChange} required />
          </Field>
          <Field>
            <label>10. Business Registration Number</label>
            <input name="businessRegistrationNumber" value={formData.businessRegistrationNumber} onChange={handleInputChange} required />
          </Field>
        </Grid2>

        <Grid2>
          <Field>
            <label>11. FAL Premises Code (If available)</label>
            <input name="falPremisesCode" value={formData.falPremisesCode} onChange={handleInputChange} />
          </Field>
          <Field>
            <label>12. Date of Listing</label>
            <input type="date" name="dateOfListing" value={formData.dateOfListing} onChange={handleInputChange} />
          </Field>
        </Grid2>

        <Button type="submit" disabled={submitting}>
          {submitting ? 'Submitting...' : 'Submit Application'}
        </Button>

      </form>
    </FormCard>
  );
};

export default FoodPremisesApplicationForm;
